// Core
import { createActions } from 'redux-actions';

export const offersActions = createActions({
    GET_OFFER:         (offerId) => offerId,
    GET_OFFER_SUCCESS: () => void 0,
    GET_OFFER_FAIL:    (error) => error,
    ADD_OFFERS:        (offers) => offers,
    SET_EXPIRED:       (offerId) => offerId,
});
